import React, {Component}   from 'react';
import {
  Table as TableB,
  Button,
  InputGroup,
  FormControl,
  OverlayTrigger,
  Tooltip
}                           from 'react-bootstrap';
import moment               from 'moment';
import Select               from 'react-select';
import                           'react-select/dist/react-select.css';

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';

import {AUDIT_TRAIL}        from 'actions/const';

class Table extends Component {
  render() {

    let {
      mode,
      tableData,
      filterUser,
      filterModule,
      filterAction,
      filterStartDate,
      filterEndDate
    } = this.props.auditTrail;

    let {
      setValue
    } = this.props.actions;

    let {
      isLoading,
      loadOptions,
      stateSetter,
      getAuditTrails,
      accessible
    } = this.props;

    var tr = '';

    const TTview = (<Tooltip id="tooltip">View</Tooltip>);

    var accessListClass = 'AccessListWeb';
    var moduleClass = 'ModulesWeb';

    if (mode !== 'AuditTrailsWeb') {
      accessListClass = 'AccessListApp';
      moduleClass = 'ModulesApp';
    }

    var displayTD = ((mode === 'AuditTrailsWeb') ? '' : 'none');

    if (isLoading) {
      tr = (
        <tr>
          <td colSpan={15} style={{
            textAlign: 'center',
            color: '#808080'
          }}>
            <i className="fa fa-spinner fa-spin fa-3x"></i>
          </td>
        </tr>
      );
    } else if (tableData.length === 0) {
      tr = (
        <tr>
          <td colSpan={15} style={{
              textAlign: 'center',
              color: '#808080'}}>
          No Data Available
        </td>
        </tr>
      );
    } else {
      tr = tableData.map((data, index) =>
        <tr key={index}>
          <td>{(typeof data.get('User') !== 'undefined' && data.get('User') !== null) ? data.get('User').get('name'): ''}</td>
          {/*<td>{(typeof data.get(accessListClass) !== 'undefined') ? data.get(accessListClass).get('Apps').get('name') : ''}</td>*/}
          <td>{(typeof data.get(accessListClass) !== 'undefined') ? data.get(accessListClass).get(moduleClass).get('name') : ''}</td>
          <td>{(typeof data.get(accessListClass) !== 'undefined') ? data.get(accessListClass).get('Actions').get('name') : ''}</td>
          {/*<td>{(typeof data.params !== 'undefined') ? data.params : ''}</td>
          <td style={{ display: displayTD }}>{(typeof data.client_ip !== 'undefined') ? data.client_ip : ''}</td>
          <td style={{ display: displayTD }}>{(typeof data.localIp !== 'undefined') ? data.localIp : ''}</td>
          <td style={{ display: displayTD }}>{(typeof data.userAgent !== 'undefined') ? data.userAgent : ''}</td>*/}
          <td>{(typeof data.createdAt !== 'undefined') ? moment(data.createdAt).format('MMMM Do YYYY, h:mm:ss a') : ''}</td>
          <td>
            <OverlayTrigger  placement="top" overlay={TTview}>
              <a
                className="fa fa-eye fa-lg"
                href="javascript:void(0)"
                onClick={() => (accessible('VIEW') === '') ? stateSetter([{state: 'showModal', value: true}, {state: 'selectedData', value: data}]) : {}}
                style={{ display: accessible('VIEW') }}
                >
              </a>
            </OverlayTrigger>
          </td>
        </tr>
      );
    }

    return (
      <TableB hover responsive>
        <thead>
          <tr>
            <th>USER</th>
            {/*<th>App</th>*/}
            <th>MODULE</th>
            <th>ACTION</th>
            {/*<<th>Parameter</th>
            <th style={{ display: displayTD }}>Client IP</th>
            <th style={{ display: displayTD }}>Local IP</th>
            <th style={{ display: displayTD }}>User Agent</th>*/}
            <th>DATE</th>
            <th></th>
          </tr>
          <tr>
            <td>
              <Select.Async
                autoload={false}
                value={filterUser}
                loadOptions={(input, cb) => loadOptions(input, cb, 'User', 'name')}
                onChange={(val) => setValue(AUDIT_TRAIL, 'filterUser', val)}
                />
            </td>
            <td>
              <Select.Async
                autoload={false}
                value={filterModule}
                loadOptions={(input, cb) => loadOptions(input, cb, 'ModulesWeb', 'name')}
                onChange={(val) => setValue(AUDIT_TRAIL, 'filterModule', val)}
                />
            </td>
            <td>
              <Select.Async
                autoload={false}
                value={filterAction}
                loadOptions={(input, cb) => loadOptions(input, cb, 'Actions', 'name')}
                onChange={(val) => setValue(AUDIT_TRAIL, 'filterAction', val)}
                />
            </td>
            <td style={{ width: '407px'}}>
              <InputGroup style={{ width: '407px'}}>
                <FormControl
                  type="date"
                  value={filterStartDate.format('YYYY-MM-DD')}
                  onChange={(e) => setValue(AUDIT_TRAIL, 'filterStartDate', e.target.value ? moment(e.target.value ) : moment())}
                  />
                <InputGroup.Addon>to</InputGroup.Addon>
                <FormControl
                  type="date"
                  value={filterEndDate.format('YYYY-MM-DD')}
                  onChange={(e) => setValue(AUDIT_TRAIL, 'filterEndDate', e.target.value ? moment(e.target.value ) : moment())}
                  />
              </InputGroup>
            </td>
            <td>
              <Button
                className="btn btn-primary"
                onClick={() => (accessible('FILTER') === '') ? getAuditTrails() : {}}
                style={{ display: accessible('FILTER') }}
                >
                Search
              </Button>
            </td>
          </tr>
        </thead>
        <tbody>
          {tr}
        </tbody>
      </TableB>
    );
  }
}

function mapStateToProps(state) {
	var {auditTrail} = state;
	const props = {
		auditTrail
	};
	return props;
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: generics.setValue
	};
	const actionMap = {
		actions: bindActionCreators(actions, dispatch)
	};
	return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(Table);



// WEBPACK FOOTER //
// ./components/AuditTrail/Table.js